<template>
  <div class="flex">
    <div
      v-if="optOut"
      :class="[
        scrollAgreement
          ? ['block max-h-36 overflow-y-auto px-2 rounded-xl', bg]
          : 'leading-6'
      ]"
    >
      <HpFormCheckboxGroup v-model="consent" boxed>
        <BaseFormCheckbox
          id="tcpa-check"
          class="!border-none !bg-transparent"
          :unchecked-value="false"
          :value="consent"
        >
          <p class="leading-6" v-html="text"></p>
        </BaseFormCheckbox>
      </HpFormCheckboxGroup>
    </div>
    <small
      v-else
      :class="[
        'disclaimer overflow-x-auto pl-5 pr-5 text-base leading-6',
        {
          'block max-h-36 overflow-scroll rounded-xl p-3 leading-normal': scrollAgreement
        },
        {
          [bg]: true
        }
      ]"
      v-html="text"
    ></small>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      text: string
      bg?: string
      optOut?: boolean | null | undefined
      scrollAgreement?: boolean | null | undefined
    }>(),
    {
      bg: 'bg-gray-200/70'
    }
  )

  const consent = defineModel<boolean>()

  consent.value = !props.optOut
</script>

<style scoped>
  .disclaimer {
    &:deep(a) {
      @apply text-base font-semibold;
    }
  }
</style>
